<template>
  <div style="margin-top: 63px">
    <div class="hero-1">
      <div class="text-1">
        <div style="font-weight: 700; font-size: 40px" v-html="$t('faqNormalHeroTitle')">
        </div>
        <div style="font-weight: 400; font-size: 15px">
          {{ $t('faqHeroDescription') }}
        </div>
      </div>
    </div>
    <v-row style="padding: 70px 102px; background-color: #F5F6F9;">
      <v-col cols="3">
        <v-card style="padding: 27.5px 30px; border-radius: 20px">
          <div class="d-flex flex-column" style="gap: 15px">
            <div v-for="(item, idx) in program" :key="idx" :class="[
              selectedProgram == idx ? 'program-active' : '',
              'program',
            ]" @click="changeProgram(idx, item.key)">
              {{ $t(`faqProgram.${item.name}`) }}
            </div>
            <v-btn block elevation="0" class="btn-call-b1" @click="sendToWa">
              {{ $t('faqContactUsButton') }}
            </v-btn>
          </div>
        </v-card>
      </v-col>
      <v-col>
        <v-row no-gutters v-if="program[selectedProgram].sub_program" style="gap: 10px">
          <v-chip v-for="(subItem, subIdx) in program[selectedProgram].data" :key="subIdx" :class="[
            selectedSubProgram == subIdx ? 'sub-program-active' : '',
            'sub-program',
          ]" @click="changeSubProgram(subIdx, subItem.key)">
            {{ $t(`faqProgram.${program[selectedProgram].name}Sub.${subItem.name}`) }}
          </v-chip>
        </v-row>
        <v-expansion-panels flat accordion multiple :class="program[selectedProgram].sub_program ? 'mt-10' : ''">
          <v-expansion-panel v-for="(item, idx) in dataFaq" :key="idx" class="faq-card">
            <v-expansion-panel-header>
              {{ item.title }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-html="item.description"></div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <empty-data v-if="!dataFaq.length" :message="$t('faqEmptyDataMessage')" />
      </v-col>
    </v-row>
    <v-card elevation="0" class="call-center-container">
      <v-row style="padding: 40px">
        <v-col cols="7">
          <div class="call-center-title">
            {{ $t('faqFinalCTAHeading') }}
          </div>
          <div class="call-center-desc">
            {{ $t('faqFinalCTACaption') }}
          </div>
        </v-col>
        <v-col cols="1" />
        <v-col cols="4" class="call-center-button" @click="sendToWa">
          <v-btn class="btn" elevation="0">
            {{ $t('faqContactUsButton') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import EmptyData from "../../others/EmptyData.vue";

export default {
  components: {
    EmptyData
  },
  data() {
    return {
      selectedProgram: 0,
      selectedSubProgram: 0,
      categorySelect: '',
      dataFaq: [],
      program: [
        {
          name: "general",
          key: "HOME",
          sub_program: false,
        },
        {
          name: "bootcamp",
          key: "BOOTCAMP",
          sub_program: false,
        },
        // {
        //   name: "prakerja",
        //   key: "PRAKERJA",
        //   sub_program: false,
        // },
        {
          name: "corporateService",
          key: "CORPORATE",
          sub_program: true,
          data: [
            { name: "general", key: "CORPORATE" },
            { name: "corpCollaboration", key: "COLLABORATION" },
            { name: "accelerationProgram", key: "ACCELERATION" },
            { name: "corpTraining", key: "TRAINING" },
            { name: "talentAsAService", key: "TALENT_SERVICE" },
            { name: "technologyService", key: "SERVICES" },
          ],
        },
        // {
        //   name: "kampusMerdeka",
        //   key: "KAMPUS_MERDEKA",
        //   sub_program: true,
        //   data: [
        //     { name: "general", key: "KAMPUS_MERDEKA" },
        //     { name: "magangBersertifikat", key: "MAGANG" },
        //   ],
        // },
      ],
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getFaqByName(this.categorySelect);
    },
  },
  methods: {
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Contact Us - WhatsApp - FAQ Page - Program: ${this.program[this.selectedProgram].name}`,
        value: 1,
      });
      window.open("https://wa.me/6281234567890", "_blank");
    },
    async getFaqByName(name) {
      try {
        const resp = await this.$http.get(
          `/v1/faq?category=${name}`
        );
        this.dataFaq = resp.data.data.faq || [];
        this.dataFaq = this.dataFaq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    changeProgram(idx, key) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Select Program - ${this.program[idx].name} - FAQ Page`,
        value: 1,
      });
      this.selectedProgram = idx;
      this.selectedSubProgram = 0;
      this.categorySelect = key;
      this.getFaqByName(key);
    },
    changeSubProgram(idx, key) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Select Sub-Program - ${this.program[this.selectedProgram].name} - ${this.program[this.selectedProgram].data[idx].name} - FAQ Page`,
        value: 1,
      });
      this.selectedSubProgram = idx;
      this.categorySelect = key;
      this.getFaqByName(key);
    },
  },
  mounted() {
    this.getFaqByName("HOME");
    this.$gtag.pageview(this.$route);
  }
};
</script>

<style src="./faq.css" scoped></style>